import { type Registry as Services, service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type GenericChangeset } from 'uplisting-frontend/services/repositories/-base';

export default class DirectBaseController extends BaseController {
  @service('repositories/direct-booking-configuration')
  directBookingConfigurationRepository!: Services['repositories/direct-booking-configuration'];

  @tracked configuration!: ModelRegistry['direct-booking-configuration'];
  @tracked dudaConfiguration!: ModelRegistry['duda-configuration'];

  @cached
  get changeset(): GenericChangeset<
    ModelRegistry['direct-booking-configuration']
  > {
    return this.directBookingConfigurationRepository.currentChangeset;
  }
}
